import type { FC } from "react";
import type { RecordsSourceOption } from "../../utils";
import * as S from "../../style";
import { t } from "i18next";
import { ActionLogo } from "../ActionLogo/ActionLogo";

export const RecordsSelectedOption: FC<{
  option: RecordsSourceOption;
  topLabel?: string;
}> = ({ option, topLabel }) => {
  return (
    <S.RecordsSourceOption>
      {(option.type === "trigger" || option.type === "action") && (
        <S.RecordsSourceOptionEntityInnerSelected>
          <S.RecordsSourceOptionLeftSelected>
            <ActionLogo option={option} />
          </S.RecordsSourceOptionLeftSelected>
          <S.RecordsSourceOptionMain>
            <S.RecordsSourceOptionType>
              {topLabel ??
                (option.type === "action"
                  ? t("general.action.one")
                  : t("general.trigger.one"))}
            </S.RecordsSourceOptionType>
            <S.RecordsSourceOptionName>
              {option.label}
            </S.RecordsSourceOptionName>
            {option.application?.name && (
              <S.RecordsSourceOptionApplication>
                {t("general.in")} {option.application.name}
              </S.RecordsSourceOptionApplication>
            )}
          </S.RecordsSourceOptionMain>
        </S.RecordsSourceOptionEntityInnerSelected>
      )}
    </S.RecordsSourceOption>
  );
};
